import React from "react";
import { Offcanvas } from "react-bootstrap";

const OffCanvas = ({
  show,
  handleClose,
  title,
  children,
  placement = "start",
  width = "400px",
}) => {
  return (
    <>
      <Offcanvas
        show={show}
        onHide={handleClose}
        placement={placement}
        style={{ width }} // set width from prop
        // Also override maxWidth to prevent Bootstrap limit
        className="custom-offcanvas bg-white"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="pt-0">{children}</Offcanvas.Body>
      </Offcanvas>

      <style>
        {`
          .custom-offcanvas.offcanvas-start,
          .custom-offcanvas.offcanvas-end {
            max-width: none !important;
          }
        `}
      </style>
    </>
  );
};

export default OffCanvas;
